// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2z_wh","addWidgetButton":"Header_addWidgetButton__WYjnT","dashboardTabs":"Header_dashboardTabs__16cW_","active":"Header_active__1VwL8"};